import styled from 'styled-components';

export const LoadingContainer = styled.div`
  width: 100%;
  height: 30vh;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
